module.exports = __webpack_public_path__ + "img/header-01.6144a532.png";